import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-6f0048a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { id: "footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { id: "content" }
const _hoisted_6 = { id: "address" }
const _hoisted_7 = { href: "https://beian.miit.gov.cn/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString($data.copyright), 1),
          _createElementVNode("a", _hoisted_7, _toDisplayString($data.address), 1)
        ]),
        _createElementVNode("span", null, _toDisplayString($data.tips), 1)
      ])
    ])
  ]))
}